/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assign_ConfirmInputs */

const en_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign`)
};

const fr_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigner`)
};

const de_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuordnen`)
};

const it_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegnare`)
};

const ru_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначать`)
};

const es_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignar`)
};

const zh_cn2_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分配`)
};

const ja_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割り当てる`)
};

const hi_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सौंपना`)
};

const pt_pt2_explorer_info_assign_confirm = /** @type {(inputs: Explorer_Info_Assign_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuir`)
};

/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Explorer_Info_Assign_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assign_confirm = /** @type {((inputs?: Explorer_Info_Assign_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assign_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_assign_confirm(inputs)
	if (locale === "de") return de_explorer_info_assign_confirm(inputs)
	if (locale === "it") return it_explorer_info_assign_confirm(inputs)
	if (locale === "ru") return ru_explorer_info_assign_confirm(inputs)
	if (locale === "es") return es_explorer_info_assign_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_assign_confirm(inputs)
	if (locale === "ja") return ja_explorer_info_assign_confirm(inputs)
	if (locale === "hi") return hi_explorer_info_assign_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_assign_confirm(inputs)
	return en_explorer_info_assign_confirm(inputs)
});